<template>
  <v-menu
    v-if="!isWorkableDoc"
    offset-y
    :disabled="loading"
  >
    <template v-slot:activator="{ on, attrs }">
      <template>
        <v-chip
          class="mb-2"
          :color="(documentObj.documentFiles_count > 0) ? 'green' : 'grey'"
          text-color="white"
          v-bind="attrs"
          @dblclick="goToDocumentDetail(documentObj.id)"
          v-on="on"
        >
          <v-avatar
            left
            :class="(documentObj.documentFiles_count > 0) ? 'green darken-4' : 'grey darken-4'"
          >
            <span>
              {{ documentObj.documentFiles_count }}
            </span>
          </v-avatar>
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="white"
            size="20"
            width="2"
          />
          <span
            v-else
          >
            Gestisci
          </span>
        </v-chip>
      </template>
    </template>
    <v-list>
      <v-list-item-group>
        <v-list-item
          link
          :to="{name:documentRoute,params:{id:currentProcedureId,did:documentObj.id}}"
        >
          <v-list-item-title>
            <v-icon
              small
              left
            >
              mdi-folder-open-outline
            </v-icon>
            Apri
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="documentObj.document_files.length > 0"
          link
          @click="downloadAllClick"
        >
          <v-list-item-title>
            <v-icon
              small
              left
            >
              mdi-download
            </v-icon>
            Scarica tutto
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="uploadEnabled"
          :disabled="isReadOnly"
          @click="uploadModalClick"
        >
          <v-list-item-title>
            <v-icon
              small
              left
            >
              mdi-upload
            </v-icon>
            Carica file
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="loggedUser.role === 'user' && uploadEnabled"
          @click="setModalDocumentObj(documentObj);is_show_confirm=true;"
        >
          <v-list-item-title>
            <v-icon
              small
              left
            >
              mdi-check
            </v-icon>
            Conferma documentazione
          </v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DocumentActionMenu',
  props: {
    documentObj: {
      type: Object,
      required: true,
    },
    uploadEnabled: {
      type: Boolean,
      default: true,
    },
    isWorkableDoc: {
      type: Boolean,
      default: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    documentRoute: {
      type: String,
      required: true,
    },
    isPluginVersion: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    currentProcedureId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['loggedUser']),
  },
  methods: {
    uploadModalClick() {
      this.$emit('handleUpload', this.documentObj.id)
    },
    downloadAllClick() {
      this.$emit('downloadAll', this.documentObj)
    },
    goToDocumentDetail(did) {
      this.$router.push({
        name: this.documentRoute,
        params: {
          id: this.currentProcedureId,
          did,
        },
      })
    },
  },
}
</script>
